import { command, computed, state } from 'ccstate'
import { currentRoute$, registerRoute, type RouteConfig } from './router/routeRegistry'
import { navigateInReact$ } from './router/navigate'
import { fmt, logger } from '../ccstatex/log'
import { authClient } from '../backendApi/authClient'
import *  as sentryStates from './sentryStates'

const L = logger('authStates')

export const supabaseSession_dirty$ = state(1)

export const supabaseSession$ = computed(async (get) => {
  get(supabaseSession_dirty$)
  const session = await authClient.getSession()
  return session
})

export const supabaseAuthToken$ = computed(async (get) => {
  const session = await get(supabaseSession$)
  if (!session) {
    L.debug('re-eval supabaseAuthToken$ to empty due to no session')
    return ''
  }
  L.debug(fmt`re-eval supabaseAuthToken$ to ${session.access_token}`)
  return session.access_token
})

export const initAuthStates$ = command(({get, set}) => {
  authClient.onAuthStateChange(async (event, session) => {
    L.debug(fmt`onAuthStateChange ${event}`)
    const isLoggedIn = session?.access_token
    if (isLoggedIn && get(currentRoute$)?.path === '/login') {
      set(supabaseSession_dirty$, val => val + 1)
      set(navigateInReact$, '/')
    } else if (!isLoggedIn && get(currentRoute$)?.path !== '/login') {
      set(supabaseSession_dirty$, val => val + 1)
      set(navigateInReact$, '/login')
    }
    sentryStates.afterAuth(session?.user)
  })
})

export function registerProtectedRoute(config: RouteConfig) {
  const newConfig = {
    ...config
  }
  newConfig.onBeforeNavigate = command(async ({get, set}, signal) => {
    const authToken = await get(supabaseAuthToken$)
    signal.throwIfAborted()
    if (!authToken) {
      L.debug('no logged in, redirect to /login')
      await set(navigateInReact$, '/login')
      return
    }
    if (config.onBeforeNavigate) {
      set(config.onBeforeNavigate, signal)
    }
  })
  registerRoute(newConfig)
}